<template>
  <div class="products">
    <!-- 页面标题 -->
    <section class="page-title">
      <div class="container">
        <h1>产品中心</h1>
        <p>为您提供专业的物联网产品解决方案</p>
      </div>
    </section>

    <!-- 产品分类 -->
    <section class="products-section">
      <div class="container">
        <el-tabs v-model="activeCategory" @tab-click="handleCategoryChange">
          <el-tab-pane label="全部产品" name="all">
            <el-row :gutter="30">
              <el-col :xs="24" :sm="12" :md="8" v-for="(product, index) in filteredProducts" :key="index">
                <div class="product-card" @click="showProductDetail(product)">
                  <div class="product-image">
                    <img :src="product.image" :alt="product.name">
                  </div>
                  <div class="product-content">
                    <h3>{{ product.name }}</h3>
                    <p v-for="(description, idx) in product.descriptions" :key="idx">{{ description }}</p>
                    
                    <!-- <div class="features">
                      <span v-for="(feature, idx) in product.features" :key="idx">{{ feature }}</span>
                    </div> -->
                    <!-- <el-button type="text" class="learn-more">
                      查看详情 <i class="el-icon-arrow-right"></i>
                    </el-button> -->
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="SIM卡" name="industrial">
            <el-row :gutter="30">
              <el-col :xs="24" :sm="12" :md="8" v-for="(product, index) in filteredProducts" :key="index">
                <div class="product-card" @click="showProductDetail(product)">
                  <div class="product-image">
                    <img :src="product.image" :alt="product.name">
                  </div>
                  <div class="product-content">
                    <h3>{{ product.name }}</h3>
                    <p v-for="(description, idx) in product.descriptions" :key="idx">{{ description }}</p>
                    <!-- <div class="features">
                      <span v-for="(feature, idx) in product.features" :key="idx">{{ feature }}</span>
                    </div> -->
                    <!-- <el-button type="text" class="learn-more">
                      查看详情 <i class="el-icon-arrow-right"></i>
                    </el-button> -->
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="eSIM" name="smart-city">
            <el-row :gutter="30">
              <el-col :xs="24" :sm="12" :md="8" v-for="(product, index) in filteredProducts" :key="index">
                <div class="product-card" @click="showProductDetail(product)">
                  <div class="product-image">
                    <img :src="product.image" :alt="product.name">
                  </div>
                  <div class="product-content">
                    <h3>{{ product.name }}</h3>
                    <p v-for="(description, idx) in product.descriptions" :key="idx">{{ description }}</p>
                    <!-- <div class="features">
                      <span v-for="(feature, idx) in product.features" :key="idx">{{ feature }}</span>
                    </div> -->
                    <!-- <el-button type="text" class="learn-more">
                      查看详情 <i class="el-icon-arrow-right"></i>
                    </el-button> -->
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="vSIM" name="agriculture">
            <el-row :gutter="30">
              <el-col :xs="24" :sm="12" :md="8" v-for="(product, index) in filteredProducts" :key="index">
                <div class="product-card" @click="showProductDetail(product)">
                  <div class="product-image">
                    <img :src="product.image" :alt="product.name">
                  </div>
                  <div class="product-content">
                    <h3>{{ product.name }}</h3>
                    <p v-for="(description, idx) in product.descriptions" :key="idx">{{ description }}</p>
                    <!-- <div class="features">
                      <span v-for="(feature, idx) in product.features" :key="idx">{{ feature }}</span>
                    </div> -->
                    <!-- <el-button type="text" class="learn-more">
                      查看详情 <i class="el-icon-arrow-right"></i>
                    </el-button> -->
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </div>
    </section>

    <!-- 产品详情对话框 -->
    <el-dialog
      :title="selectedProduct ? selectedProduct.name : ''"
      :visible.sync="dialogVisible"
      width="80%"
      :before-close="handleClose">
      <div class="product-detail" v-if="selectedProduct">
        <div class="detail-image">
          <img :src="selectedProduct.image" :alt="selectedProduct.name">
        </div>
        <div class="detail-content">
          <h2>{{ selectedProduct.name }}</h2>
          <p class="description">{{ selectedProduct.description }}</p>
          <div class="specifications">
            <h3>产品规格</h3>
            <el-table :data="selectedProduct.specifications" style="width: 100%">
              <el-table-column prop="name" label="参数名称" width="180"></el-table-column>
              <el-table-column prop="value" label="参数值"></el-table-column>
            </el-table>
          </div>
          <div class="features">
            <h3>产品特点</h3>
            <ul>
              <li v-for="(feature, index) in selectedProduct.features" :key="index">
                <i class="el-icon-check"></i>
                {{ feature }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'Products',
  data() {
    return {
      activeCategory: 'all',
      dialogVisible: false,
      selectedProduct: null,
      products: [
        {
          id: 1,
          name: '',
          category: 'industrial',
          description: '具有移动10648、电信10649、联通10646三大运营商2/3/4G物联卡的长期稳定供货资源',
          image: require('@/assets/images/sim.png'),
          descriptions:['具有移动10648、电信10649、联通10646三大运营商2/3/4G物联卡的长期稳定供货资源','根据使用场景和环境，提供插卡式（适合大、中、小SIM卡插槽）、贴片式（5*6MM）和ESIM卡（空中写号）三种类型','全国使用，无长途、漫游费，专用物联APN接入，网络更稳定'],
          features: ['多协议支持', '实时采集', '远程配置', '数据加密'],
          specifications: [
            { name: '工作温度', value: '-20℃ ~ 60℃' },
            { name: '通信接口', value: 'RS485/RS232/以太网' },
            { name: '供电方式', value: 'DC 12V/24V' },
            { name: '防护等级', value: 'IP65' }
          ]
        },
        {
          id: 2,
          name: '',
          category: 'smart-city',
          description: '城市环境综合监测系统，实时监测空气质量、噪声等环境指标',
          image: require('@/assets/images/esim.png'),
          descriptions:['eSIM 是一种嵌入式 SIM 卡，允许您在无需物理 SIM 卡的情况下激活移动数据套餐。','即时激活，支持多设备使用，畅享全球高速网络，无限下载次数','支持自动充值和自动续订、无限速、支持热点、支持全球200+国家'],
          features: ['多参数监测', '数据可视化', '预警系统', '远程管理'],
          specifications: [
            { name: '监测参数', value: 'PM2.5/PM10/NO2/SO2/噪声' },
            { name: '采样周期', value: '1分钟' },
            { name: '数据传输', value: '4G/NB-IoT' },
            { name: '电池续航', value: '≥7天' }
          ]
        },
        {
          id: 3,
          name: '',
          category: 'agriculture',
          description: '智能农业控制系统，实现温室大棚的自动化控制',
          image: require('@/assets/images/vsim.png'),
          descriptions:['将SIM卡信息存储在云端，通过动态选择最优运营商网络实现全球通信','即时激活，随时使用','完全虚拟化、云端动态切换'],
          features: ['环境控制', '远程监控', '定时任务', '数据统计'],
          specifications: [
            { name: '控制通道', value: '8路继电器输出' },
            { name: '传感器接口', value: '4路模拟量输入' },
            { name: '通信方式', value: 'WiFi/4G' },
            { name: '工作电压', value: 'AC 220V' }
          ]
        }
      ]
    }
  },
  computed: {
    filteredProducts() {
      if (this.activeCategory === 'all') {
        return this.products
      }
      return this.products.filter(product => product.category === this.activeCategory)
    }
  },
  methods: {
    handleCategoryChange(tab) {
      this.activeCategory = tab.name
    },
    showProductDetail(product) {
      this.selectedProduct = product
      this.dialogVisible = true
    },
    handleClose(done) {
      this.selectedProduct = null
      done()
    }
  }
}
</script>

<style lang="scss" scoped>
.products {
  .page-title {
    background: linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url('~@/assets/images/products-bg.jpg');
    background-size: cover;
    background-position: center;
    color: #fff;
    padding: 100px 0;
    text-align: center;
    
    h1 {
      font-size: 48px;
      margin-bottom: 20px;
    }
    
    p {
      font-size: 20px;
      opacity: 0.9;
    }
  }
  
  .products-section {
    padding: 80px 0;
    
    .product-card {
      background: #fff;
      border-radius: 8px;
      overflow: hidden;
      box-shadow: 0 4px 6px rgba(0,0,0,0.1);
      margin-bottom: 30px;
      cursor: pointer;
      transition: transform 0.3s;
      
      &:hover {
        transform: translateY(-5px);
        
        .product-image img {
          transform: scale(1.1);
        }
        
        .learn-more i {
          transform: translateX(5px);
        }
      }
      
      .product-image {
        height: 220px;
        overflow: hidden;
        
        img {
          // width: 100%;
          // height: 100%;
          object-fit: cover;
          transition: transform 0.3s;
        }
      }
      
      .product-content {
        padding: 20px;
        height: 230px;
        
        h3 {
          font-size: 20px;
          margin-bottom: 10px;
          color: #2c3e50;
        }
        
        p {
          color: #666;
          margin-bottom: 15px;
          line-height: 1.6;
        }
        
        .features {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
          margin-bottom: 15px;
          
          span {
            background: #f0f2f5;
            padding: 4px 12px;
            border-radius: 4px;
            font-size: 14px;
            color: #666;
          }
        }
        
        .learn-more {
          padding: 0;
          font-size: 16px;
          
          i {
            margin-left: 5px;
            transition: transform 0.3s;
          }
        }
      }
    }
  }
}

.product-detail {
  .detail-image {
    margin-bottom: 30px;
    
    img {
      width: 100%;
      max-height: 400px;
      object-fit: cover;
      border-radius: 8px;
    }
  }
  
  .detail-content {
    h2 {
      font-size: 24px;
      margin-bottom: 20px;
      color: #2c3e50;
    }
    
    .description {
      color: #666;
      margin-bottom: 30px;
      line-height: 1.6;
    }
    
    h3 {
      font-size: 18px;
      margin-bottom: 15px;
      color: #2c3e50;
    }
    
    .features {
      margin-top: 30px;
      
      ul {
        list-style: none;
        padding: 0;
        
        li {
          display: flex;
          align-items: center;
          margin-bottom: 10px;
          color: #666;
          
          i {
            color: #409EFF;
            margin-right: 10px;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .products {
    .page-title {
      padding: 60px 0;
      
      h1 {
        font-size: 32px;
      }
      
      p {
        font-size: 16px;
      }
    }
    
    .products-section {
      padding: 40px 0;
    }
  }
  
  .product-detail {
    .detail-image {
      img {
        max-height: 300px;
      }
    }
  }
}
</style> 